import * as React from "react";
import { Link } from "@fluentui/react";
import { emptyChar } from "../../constants/uiConstants";
import { OciResourceType } from "../../helpers/resourceHelper";
import { AnalyticsDataPage, useAnalytics } from "../../hooks/useAnalytics";
import { AzureSubscriptionSummaryExt } from "../../hooks/useSubscriptions";
import { getOCIConsoleUrl, getOciRegion } from "../../utils";

export interface OciLinkProps {
  ociResourceType: OciResourceType;
  ociResourcePath: string | undefined;
  ociResourceName: string | undefined;
  location: string;
  subscription: AzureSubscriptionSummaryExt | undefined;
  analytics: AnalyticsDataPage;
}

export const OciLink = (
  { ociResourceType, ociResourcePath, ociResourceName, location, subscription, analytics }: OciLinkProps,
): JSX.Element => {
  const { trackOciLinkNavigate } = useAnalytics();

  const ociConsoleUrl = getOCIConsoleUrl();
  const ociTenancyParam = subscription?.ociTenancyName ? `&tenant=${subscription.ociTenancyName}` : "";
  const ociDomainParam = subscription?.ociDomainName ? `&domain=${subscription.ociDomainName}` : "";
  const region = getOciRegion(location);
  const ociResourceUrl = `${ociConsoleUrl}${ociResourcePath}?region=${region}${ociTenancyParam}${ociDomainParam}`;

  return (
    <>
      {!ociResourcePath && emptyChar}
      {ociResourcePath && (
        <Link
          href={ociResourceUrl}
          target="_blank"
          onClick={() => trackOciLinkNavigate(ociResourceType, analytics.pageId, analytics.panelId)}
        >
          {ociResourceName}
        </Link>
      )}
    </>
  );
};
